module.exports = __webpack_public_path__ + "static/img/no-order.d28faae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mall/no-order.png
// module id = 7+YO
// module chunks = 212